import { render, staticRenderFns } from "./ForDelivery.vue?vue&type=template&id=5730118a&scoped=true&"
import script from "./ForDelivery.vue?vue&type=script&lang=js&"
export * from "./ForDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ForDelivery.vue?vue&type=style&index=0&id=5730118a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5730118a",
  null
  
)

export default component.exports